import AppBar from '@mui/material/AppBar'

export function Header() {
  return <AppBar position="sticky" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}></AppBar>
}

export default Header
